import { Link } from "react-router";
import Picture from "../Picture/Picture.jsx";
import styles from "./CTABand.module.css";

const BACKDROP = { ratio: "auto", widths: [960, 1600], fallbackWidth: 1600 };

/**
 * The closing call to action. `variant="statement"` is the home page's ending: one large
 * centred line over a full-width image (`image`, a Picture base path), with an optional
 * `secondary` text link beside the button.
 */
export default function CTABand({
  title,
  text,
  to = "/demo",
  label = "Request a demo",
  variant = "band",
  image,
  secondary,
}) {
  if (variant === "statement") {
    return (
      <section className={`section section-dark ${styles.statement}`} aria-labelledby="cta-title">
        {image ? (
          <Picture src={image} alt="" {...BACKDROP} sizes="100vw" className={styles.backdrop} />
        ) : null}
        <div className={`container ${styles.statementInner}`}>
          <h2 id="cta-title" className={styles.statementTitle}>
            {title}
          </h2>
          {text ? <p className={styles.statementText}>{text}</p> : null}
          <div className={styles.actions}>
            <Link to={to} className="btn btn-primary">
              {label}
            </Link>
            {secondary ? (
              <Link to={secondary.to} className={styles.secondary}>
                {secondary.label}
              </Link>
            ) : null}
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className={`section section-dark ${styles.band}`} aria-labelledby="cta-title">
      <div className={`container ${styles.inner}`}>
        <div>
          <h2 id="cta-title">{title}</h2>
          {text ? <p className={styles.text}>{text}</p> : null}
        </div>
        <Link to={to} className="btn btn-primary">
          {label}
        </Link>
      </div>
    </section>
  );
}
